import {
  SameRankIcon,
  TriangleDownIcon,
  TriangleUpIcon,
} from '../../../shared/components/atoms/Icon/foundation_icons';
import { IStoreRanking, NewCreatorRankingType, RankingPageType } from '../type';
import {
  CREATOR_RANKING_MONTHLY_REDIS_KEY,
  CREATOR_RANKING_REALTIME_REDIS_KEY,
  CREATOR_RANKING_WEEKLY_REDIS_KEY,
  NEW_CREATOR_RANKING_MONTHLY_REDIS_KEY,
} from '../constant';
import { format, startOfMonth, startOfWeek } from 'date-fns';

export const diffIcons = {
  up: TriangleUpIcon(),
  down: TriangleDownIcon(),
  zero: SameRankIcon(),
  new: 'NEW',
  none: '',
} as const;

export type DiffIconValue = (typeof diffIcons)[keyof typeof diffIcons];
export type DiffIconKey = keyof typeof diffIcons;

type GetUpDownStateFunc = (rank?: IStoreRanking | null) => {
  state: DiffIconKey;
  diff: number;
};

export const getUpDownState: GetUpDownStateFunc = (rank) => {
  if (!rank || !(rank.current_rank || rank.previous_rank || rank.score)) {
    return {
      state: 'none',
      diff: 0,
    };
  }
  if (rank.previous_rank === null) {
    return {
      state: 'new',
      diff: 0,
    };
  }
  if (rank.previous_rank === rank.current_rank) {
    return {
      state: 'zero',
      diff: 0,
    };
  }
  if (rank.previous_rank > rank.current_rank) {
    return {
      state: 'up',
      diff: rank.previous_rank - rank.current_rank,
    };
  }
  // previous_rank < current_rank
  return {
    state: 'down',
    diff: rank.previous_rank - rank.current_rank,
  };
};

export const makeRankingRedisKey = (date: Date, type: RankingPageType) => {
  if (type === 'realtime') {
    return CREATOR_RANKING_REALTIME_REDIS_KEY;
  }
  if (type === 'monthly') {
    return `${CREATOR_RANKING_MONTHLY_REDIS_KEY}:${format(startOfMonth(date), 'yyyy-MM')}`;
  }
  return `${CREATOR_RANKING_WEEKLY_REDIS_KEY}:${format(startOfWeek(date), 'yyyy-MM-dd')}`;
};

/**
 * 이달의 신규 크리에이터 레디스키
 */
export const makeNewCreatorRankinRedisKey = (date: Date, type: NewCreatorRankingType) => {
  if (type === NewCreatorRankingType.MONTHLY) {
    return `${NEW_CREATOR_RANKING_MONTHLY_REDIS_KEY}:${format(startOfMonth(date), 'yyyy-MM')}`;
  }
  throw new Error('invalid redis key');
};
